import { useSelector } from "react-redux";
import { CreateDepartment } from "../../../store/department-store/department-actions"; 
import DepartmentForms from "../../../components/Forms/DepartmentForms";
import { GetDepartments } from "../../../store/department-store/department-actions";

const DepartmentCreate = () => {
  const department = useSelector((state) => state.department.department);

  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "37.1rem" }}>
      <DepartmentForms actionDepartment={CreateDepartment} department={department} />
      </div>
    </>
  );
};
export default DepartmentCreate;
